import api from "./api";

export const getRepairOrders = async (params = {}) => {
  try {
    const body = {
      party_uuid: params.party_uuid,
      page: params.page || 1,
      page_size: params.page_size || 20,
      // order_by: params.order_by || ["created_at"],
      order_by:["created_at"],
      order_direction: params.order_direction || ["DESC"],
      filters: params.filters || {},
      search: {keyword: params.search || null},
    };

    const response = await api.post("/v1/tenant/repair_order/list", body);
    return response.data;
  } catch (error) {
    console.error("Error fetching repair orders:", error);
    throw error;
  }
};

export const getRepairOrderStatuses = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };

    if (search) {
      body.search = search;
    }

    const response = await api.post(
      "/v1/tenant/repair_orders/status/list_filter",
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching repair order statuses:", error);
    throw error;
  }
};

export const getRepairOrderModels = async (partyUuid, search = null) => {
  try {
    const body = {
      party_uuid: partyUuid,
    };

    if (search) {
      body.search = search;
    }

    const response = await api.post(
      "/v1/tenant/repair_orders/model/list_filter",
      body
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching repair order models:", error);
    throw error;
  }
};

